import React, { Component } from "react";
import { connect, type ConnectedProps } from "react-redux";
import type { RouteComponentProps } from "react-router-dom";

import { getPatientId } from "../../actions/get_patient_id";
import remoteLog from "../../common/logging";
import Loader from "../../components/common/loadingInProgress";
import type { RootState } from "../../store";
import PatientDeliveries from "./patient_show/patient_deliveries";
import PatientId from "./patient_show/patient_id";

const mapStateToProps = (state: RootState) => {
  return {
    patient: state.patient,
  };
};

const mapDispatchToProps = {
  getPatient: getPatientId,
};

type PatientDeliveryPageBodyProps = PropsFromRedux & RouteComponentProps<{ patient_id: string }>;

class PatientDeliveryPageBody extends Component<PatientDeliveryPageBodyProps> {
  componentDidMount() {
    const patient_id = this.props.match.params.patient_id;
    this.props.getPatient(patient_id);
  }

  componentDidCatch(e: Error) {
    remoteLog(e, "patient_delivery_page_body");
  }

  render() {
    if (this.props.patient.patient_id) {
      return (
        <div className="row">
          <div className="col-md-8">
            <PatientDeliveries />
          </div>
          <div className="col-md-4">
            <PatientId />
          </div>
        </div>
      );
    }

    return <Loader />;
  }
}

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;
export default connector(PatientDeliveryPageBody);
